import { defineComponent as u, createVNode as r, h as m } from "vue";
import d from "./assets/utils/scrollbar-width.js";
import { t as p } from "./util-b2b0dc25.js";
import { on as h, off as c } from "./assets/utils/dom.js";
import { BAR_MAP as f, renderThumbStyle as b } from "./scrollbar2/util.js";
const l = /* @__PURE__ */ u({
  name: "Bar",
  props: {
    vertical: Boolean,
    size: String,
    move: Number
  },
  computed: {
    bar() {
      return f[this.vertical ? "vertical" : "horizontal"];
    },
    wrap() {
      return this.$parent.wrap;
    }
  },
  render() {
    const {
      size: t,
      move: e,
      bar: s
    } = this;
    return r("div", {
      class: ["el-scrollbar__bar", "is-" + s.key],
      onMousedown: this.clickTrackHandler
    }, [r("div", {
      ref: "thumb",
      class: "el-scrollbar__thumb",
      onMousedown: this.clickThumbHandler,
      style: b({
        size: t,
        move: e,
        bar: s
      })
    }, null)]);
  },
  methods: {
    clickThumbHandler(t) {
      t.ctrlKey || t.button === 2 || (this.startDrag(t), this[this.bar.axis] = t.currentTarget[this.bar.offset] - (t[this.bar.client] - t.currentTarget.getBoundingClientRect()[this.bar.direction]));
    },
    clickTrackHandler(t) {
      const e = Math.abs(t.target.getBoundingClientRect()[this.bar.direction] - t[this.bar.client]), s = this.$refs.thumb[this.bar.offset] / 2, i = (e - s) * 100 / this.$el[this.bar.offset];
      this.wrap[this.bar.scroll] = i * this.wrap[this.bar.scrollSize] / 100;
    },
    startDrag(t) {
      t.stopImmediatePropagation(), this.cursorDown = !0, h(document, "mousemove", this.mouseMoveDocumentHandler), h(document, "mouseup", this.mouseUpDocumentHandler), document.onselectstart = () => !1;
    },
    mouseMoveDocumentHandler(t) {
      if (this.cursorDown === !1)
        return;
      const e = this[this.bar.axis];
      if (!e)
        return;
      const s = (this.$el.getBoundingClientRect()[this.bar.direction] - t[this.bar.client]) * -1, i = this.$refs.thumb[this.bar.offset] - e, o = (s - i) * 100 / this.$el[this.bar.offset];
      this.wrap[this.bar.scroll] = o * this.wrap[this.bar.scrollSize] / 100;
    },
    mouseUpDocumentHandler(t) {
      this.cursorDown = !1, this[this.bar.axis] = 0, c(document, "mousemove", this.mouseMoveDocumentHandler), document.onselectstart = null;
    }
  },
  destroyed() {
    c(document, "mouseup", this.mouseUpDocumentHandler);
  }
}), H = /* @__PURE__ */ u({
  name: "rScrollBar2",
  components: {
    Bar: l
  },
  props: {
    native: Boolean,
    wrapStyle: {},
    wrapClass: {},
    viewClass: {},
    viewStyle: {},
    noresize: Boolean,
    // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
    tag: {
      type: String,
      default: "div"
    }
  },
  data() {
    return {
      sizeWidth: "0",
      sizeHeight: "0",
      moveX: 0,
      moveY: 0
    };
  },
  computed: {
    wrap() {
      return this.$refs.wrap;
    }
  },
  render() {
    const t = d();
    let e = this.wrapStyle;
    if (t) {
      const a = `-${t}px`, n = `margin-bottom: ${a}; margin-right: ${a};`;
      Array.isArray(this.wrapStyle) ? (e = p(this.wrapStyle), e.marginRight = e.marginBottom = a) : typeof this.wrapStyle == "string" ? e += n : e = n;
    }
    const s = m(this.tag, {
      class: ["el-scrollbar__view", this.viewClass],
      style: this.viewStyle,
      ref: "resize"
    }, this.$slots.default()), i = r("div", {
      ref: "wrap",
      style: e,
      onScroll: this.handleScroll,
      class: [this.wrapClass, "el-scrollbar__wrap", t ? "" : "el-scrollbar__wrap--hidden-default"]
    }, [[s]]);
    let o;
    return this.native ? o = [r("div", {
      ref: "wrap",
      class: [this.wrapClass, "el-scrollbar__wrap"],
      style: e
    }, [[s]])] : o = [i, r(l, {
      move: this.moveX,
      size: this.sizeWidth
    }, null), r(l, {
      vertical: !0,
      move: this.moveY,
      size: this.sizeHeight
    }, null)], r("div", {
      class: "el-scrollbar"
    }, [o]);
  },
  methods: {
    handleScroll() {
      const t = this.wrap;
      this.moveY = t.scrollTop * 100 / t.clientHeight, this.moveX = t.scrollLeft * 100 / t.clientWidth;
    },
    update() {
      const t = this.wrap;
      if (!t)
        return;
      const e = t.clientHeight * 100 / t.scrollHeight, s = t.clientWidth * 100 / t.scrollWidth;
      this.sizeHeight = e < 100 ? e + "%" : "", this.sizeWidth = s < 100 ? s + "%" : "";
    }
  },
  mounted() {
    this.native || this.$nextTick(this.update);
  }
});
export {
  H as S
};
